import ConsumerRefService from "@api/consumer/consumerRefService";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {useNavigate} from "react-router";
import RefForm from "./refForm";
import {RefFormValues, TargetType} from "./forms/refBaseInfoBlock";
import withPage from "@components/hoc/withPage";

const AddRefForm: FC = () => {

    const navigate = useNavigate();
    const initialValues: RefFormValues = {
        name: '',
        description: '',
        targetType: TargetType.All,
        hidden: false,
        isActive: false,
        order: 0
    }

    const onSubmit = useCallback(async (values: RefFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putRef({
            name: values.name,
            description: values.description,
            hidden: values.hidden
        });

        if(result.success) {
            toastr.success('Реферальная система', 'Бонус создан');
            navigate(`/consumer/refs/${result.data.id}/`, { replace: true });
        }
        else {
            toastr.error('Реферальная система', 'Неизвестная ошибка');
        }
    }, [navigate]);

    return (
        <RefForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={false}
            cancelUrl="/consumer/refs/" />
    )
}

export default withPage(AddRefForm);
